<template>
	<modal v-if="modalOpen" @close="closeModal" class="remove-product-modal">
		<div slot="header" class="display-1 mobile-headline-6">{{ getHeaderText }}</div>
		<div class="content body-1">
			<div v-if="cannotRemove">
				<p>
					<!-- product being removed -->
					<span class="product-name" v-html="getName" /> cannot be removed while

					<!-- products blocking removal -->
					<span class="product-name" v-html="getBlockingProducts" />
					<span v-if="blockingProductSize > 1"> are </span>
					<span v-else> is </span> selected.
				</p>
			</div>
			<div v-else>
				<p><span class="product-name" v-html="getName" /> will be removed.</p>
			</div>
		</div>
		<div class="footer" slot="footer">
			<md-button class="md-primary md-button-large" :class="{'md-raised': cannotRemove}" @click.stop="closeModal">
				<span v-if="cannotRemove">Ok</span>
				<span v-else> Cancel </span>
			</md-button>
			<md-button
				v-if="!cannotRemove"
				@click="removeProduct"
				id="remove-product-btn"
				class="md-primary md-raised md-button-large has-icon remove-product"
			>
				<base-icon class="trash" icon-name="delete" />
				Remove
			</md-button>
		</div>
	</modal>
</template>
<script>
import {trackEvent} from '@/services/tracking.js';

export default {
	name: 'RemoveProductModal',
	data() {
		return {
			modalOpen: false,
			header: '',
			args: null,
			blockingNames: '',
		};
	},
	methods: {
		init(args) {
			this.args = {...args};
			if (this.cannotRemove) this.buildBlocking();
			this.modalOpen = true;
		},
		async buildBlocking() {
			const list = [];
			for (const product of this.args?.blocked)
				list.push(`"${await this.$store.getters['workflow/productName'](product)}"`);

			this.blockingNames = list.join(', ').replace(/,\s([^,]+)$/, ' and $1');
		},

		async removeProduct() {
			const {stepName, key} = this.args;
			const wfs = await this.$store.getters['workflow/wfStep'](stepName);
			wfs.selected = wfs.selected.filter((selected) => selected.initial !== key);

			trackEvent('ctaClick', {eVar58: 'Remove Product | Workflow Configurator'});

			this.$emit('doWeShowRuleModal', {wfs, addProduct: null, removeProduct: key});
			this.closeModal();
		},

		closeModal() {
			this.modalOpen = false;
		},
	},
	computed: {
		getHeaderText() {
			return this.args.blocked ? 'Cannot remove required product' : 'Remove product';
		},
		cannotRemove() {
			return !!this.args.blocked;
		},
		getName() {
			return this.args.name ? `"${this.args.name}"` : 'Your Own Product';
		},
		getBlockingProducts() {
			return this.blockingNames;
		},
		blockingProductSize() {
			return this.args.blocked.size || 0;
		},
	},
	created() {
		this.$root.$on('removeProduct', this.init);
	},
};
</script>
<style lang="scss">
.remove-product-modal {
	&.modal-mask {
		.modal-container {
			min-height: 217px;
			padding: 24px;
			.header {
				padding-bottom: 8px;
			}
		}
	}
	.product-name {
		br {
			display: none;
		}
	}
	.footer {
		justify-content: flex-end;
		button {
			&#remove-product-btn {
				margin-left: 1rem;
				.icons {
					margin-right: 0;
				}
			}
		}
	}
}
</style>
